import { FC, useEffect, useState } from 'react';
import { UserManagementUsersEditDetailsTemplate } from '../../templates';
import { useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import Spinner from '../../atoms/Spinner/Spinner';
import { useGetUserById } from '../../../store/contextAPI/user/queries/user.queries';
import { UserDetailsDto } from '../../../store/contextAPI/user/dto/response/user-details.dto';
import userService from '../../../store/contextAPI/user/services/user.service';
import { getQueryClient } from '../../../App';

const UserManagementUsersEditDetailsPage: FC = () => {
  const clientQuery = getQueryClient();
  const { id } = useParams();
  const { data, isLoading, error } = useGetUserById(id || '');
  const [user, setUser] = useState<UserDetailsDto | null>(null);
  const keysToInvalidate = [
    {
      queryKey: ['user', id],
    },
    {
      queryKey: ['users'],
    },
  ];

  useEffect(() => {
    if (data) {
      setUser(data);
    }
  }, [data]);

  const handleOnChange = (user: UserDetailsDto) => {
    setUser(user);
  };

  const editUser = async (user: UserDetailsDto) => {
    const request = {
      companyName: user.companyName || '',
      name: user.name || '',
      usage: user.usage || '',
      verificationStatus: user.verificationStatus as any,
    };

    await userService.updateUser(user.id, request);
  };

  const { mutate: handleEditUser, isPending: isPendingEditUser } = useMutation({
    mutationFn: editUser,
    onSuccess: () =>
      keysToInvalidate.map((key) => clientQuery.invalidateQueries(key)),
    onError: (error) => console.log(error.message),
  });

  if (isLoading || isPendingEditUser) {
    return <Spinner />;
  }

  if (error) {
    return <div>{error.message}</div>;
  }

  return (
    <>
      {user && (
        <UserManagementUsersEditDetailsTemplate
          data={user}
          handleOnChange={handleOnChange}
          callbackFn={handleEditUser}
        />
      )}
    </>
  );
};

export default UserManagementUsersEditDetailsPage;
